import { render, staticRenderFns } from "./AddLetter.vue?vue&type=template&id=b786b040"
import script from "./AddLetter.vue?vue&type=script&lang=js"
export * from "./AddLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b786b040')) {
      api.createRecord('b786b040', component.options)
    } else {
      api.reload('b786b040', component.options)
    }
    module.hot.accept("./AddLetter.vue?vue&type=template&id=b786b040", function () {
      api.rerender('b786b040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/LetterTemplate/AddLetter.vue"
export default component.exports